var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useContext, useEffect } from "react";
import { Person, People } from "@reverb-ui/icons-react";
import { Avatar, Box, Center, Grid, Heading, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, Text, } from "@reverb-ui/react";
import { I18nextProvider, useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import { GtnProfile } from "./profile/gtn-profile";
import { GtnContext, GtnProvider, } from "@/shared/presentation/context-api/providers/gtn";
import { ProfileContainer } from "./profile/index";
import { CompanyContainer } from "./company";
import { UsersContainer } from "./users/index";
import { EntityProvider } from "@/shared/presentation/context-api/providers/entity";
import { UtilProvider } from "@/shared/presentation/context-api/providers/util";
import { makeEntityDatasource } from "@/main/factories/datasources/entity-datasource-factory";
import { makeUtilDatasource } from "@/main/factories/datasources/util-datasource-factory";
import { makeGtnDatasource } from "@/main/factories/datasources/gtn-datasource-factory";
import { ClientEmployeeProvider } from "@/shared/presentation/context-api/providers/client-employee";
import { makeContactDatasource } from "@/main/factories/datasources/contact-datasource-factory";
import { makeAddressDatasource } from "@/main/factories/datasources/address-datasource-factory";
import CompanyIcon from "@/assets/icons/company.svg";
import i18n from "../../../main/i18n/config";
import { my_account_en } from "../../../main/i18n/en";
import { my_account_pt_br } from "../../../main/i18n/pt-br";
import UsersTabProvider from "@/shared/presentation/context-api/providers/client-employee/users-tab";
import { makeContractDatasource } from "../../../main/factories/datasources/contract-datasource-factory";
import { makeSSOApiDatasource } from "../../../main/factories/datasources/sso-api-datasource-factory";
import { RockContentTeam } from "./rock-content-team";
var CustomTab = function (props) { return (React.createElement(Tab, __assign({ _selected: {
        fontWeight: "bold",
        color: "blue.500",
        borderColor: "blue.500",
        borderBottomWidth: "4px",
    }, _focus: { outline: "none" }, py: 4 }, props), props.children)); };
export var MyAccountTabs = function () {
    var _a, _b;
    var t = useTranslation("my-account").t;
    var _c = useContext(AuthContext), user = _c.user, talentWalletId = _c.talentWalletId, clientWallets = _c.clientWallets;
    var gtnProfile = useContext(GtnContext).profile;
    var clientWalletId = (_a = clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets[0]) === null || _a === void 0 ? void 0 : _a.walletUuid;
    var history = useHistory();
    var _d = useState(0), tabIndex = _d[0], setTabIndex = _d[1];
    var _e = useState(true), loading = _e[0], setLoading = _e[1];
    var goToProfile = function () {
        history.replace("/my-account/profile");
        setTabIndex(0);
    };
    var goToCompany = function () {
        history.replace("/my-account/company");
        setTabIndex(1);
    };
    var goToUsers = function () {
        history.replace("/my-account/users");
        setTabIndex(1);
    };
    useEffect(function () {
        i18n.addResourceBundle("en", "my-account", my_account_en);
        i18n.addResourceBundle("pt", "my-account", my_account_pt_br);
        setLoading(false);
    }, []);
    useEffect(function () {
        var shouldbe = history.location.pathname.split("/").pop();
        switch (shouldbe) {
            case "profile":
                setTabIndex(0);
                break;
            case "company":
                setTabIndex(1);
                break;
            case "users":
                setTabIndex(2);
                break;
            default:
                setTabIndex(0);
                break;
        }
    }, [history.location.pathname]);
    return (React.createElement(I18nextProvider, { i18n: i18n }, loading ? (React.createElement(Center, { w: "100%", h: "100%" },
        React.createElement(Spinner, null))) : (React.createElement(Box, { p: "8", px: "16" },
        React.createElement(Heading, { fontSize: "2xl" }, t("my-account")),
        React.createElement(Grid, { w: "100%", pt: "8", templateColumns: "2.5fr 1fr", templateRows: "1fr", gap: "4" },
            React.createElement(Box, { bg: "white", px: "1", borderRadius: "8" },
                React.createElement(Tabs, { index: tabIndex },
                    clientWalletId && (React.createElement(TabList, { bg: "white", px: 8 },
                        React.createElement(CustomTab, { onClick: function () { return goToProfile(); } },
                            React.createElement(Person, { color: "gray.400" }),
                            React.createElement(Text, { ml: "2" },
                                " ",
                                t("profile"))),
                        React.createElement(CustomTab, { p: "6", onClick: function () { return goToCompany(); } },
                            React.createElement(CompanyIcon, null),
                            React.createElement(Text, { ml: "2" },
                                " ",
                                t("company"))),
                        React.createElement(CustomTab, { onClick: function () { return goToUsers(); } },
                            React.createElement(People, { color: "gray.400" }),
                            React.createElement(Text, { ml: "2" },
                                " ",
                                t("users"))))),
                    !clientWalletId && (React.createElement(TabList, { bg: "white", px: 8, py: 2, border: "none" },
                        React.createElement(Tab, { color: "gray.800", isSelected: true, _selected: {
                                fontWeight: "bold",
                                color: "gray.800",
                                fontSize: "20px",
                            }, _focus: { outline: "none" }, py: 3 },
                            React.createElement(Person, { color: "gray.400" }),
                            React.createElement(Text, { ml: "4" },
                                " ",
                                t("profile"))))),
                    React.createElement(TabPanels, { bg: "white" },
                        React.createElement(TabPanel, null,
                            React.createElement(EntityProvider, { entityDatasource: makeEntityDatasource() },
                                React.createElement(UtilProvider, { utilDatasource: makeUtilDatasource() },
                                    React.createElement(GtnProvider, { gtnRepository: makeGtnDatasource() },
                                        React.createElement(ProfileContainer, null))))),
                        React.createElement(TabPanel, null,
                            React.createElement(ClientEmployeeProvider, { entityRepository: makeEntityDatasource(), contactRepository: makeContactDatasource(), addressRepository: makeAddressDatasource(), contractRepository: makeContractDatasource() },
                                React.createElement(CompanyContainer, null))),
                        React.createElement(TabPanel, null,
                            React.createElement(ClientEmployeeProvider, { entityRepository: makeEntityDatasource(), contactRepository: makeContactDatasource(), addressRepository: makeAddressDatasource(), contractRepository: makeContractDatasource() },
                                React.createElement(UsersTabProvider, { entityRepository: makeEntityDatasource(), ssoRepository: makeSSOApiDatasource() },
                                    React.createElement(UsersContainer, null))))))),
            React.createElement(Box, null,
                React.createElement(Grid, { rowGap: "4" },
                    React.createElement(Box, { bg: "white", p: "6", px: "8", boxShadow: "md", borderRadius: "8" },
                        React.createElement(Center, { flexDirection: "column", pt: "6" },
                            React.createElement(Avatar, { name: ((_b = user === null || user === void 0 ? void 0 : user.entity) === null || _b === void 0 ? void 0 : _b.preferredName) || (user === null || user === void 0 ? void 0 : user.entity.name), size: "xl" }),
                            React.createElement(Text, { color: "black", fontSize: "sm", mt: "5", fontWeight: "medium" }, clientWalletId
                                ? t("profile-tab.enterprise-account")
                                : t("profile-tab.personal-account")))),
                    talentWalletId && React.createElement(GtnProfile, { user: gtnProfile }),
                    clientWalletId && (React.createElement(ClientEmployeeProvider, { entityRepository: makeEntityDatasource(), contactRepository: makeContactDatasource(), addressRepository: makeAddressDatasource(), contractRepository: makeContractDatasource() },
                        React.createElement(UsersTabProvider, { entityRepository: makeEntityDatasource(), ssoRepository: makeSSOApiDatasource() },
                            React.createElement(RockContentTeam, null)))))))))));
};
